const clearFilters = {
  clearFilters: document.querySelectorAll(".jsClearFilters"),
  links: document.querySelectorAll(".jsFilterLink"),
  init() {
    this.clearFilter();
  },
  clearFilter() {
    let link = window.location;
    this.clearFilters.forEach((item) => {
     
      if(this.links.length){
          item.classList.add('activeClass')
      }
      item.addEventListener("click", () => {
        window.location.replace(link.origin + link.pathname);
      });
    });
  },
};

export default clearFilters;
